import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { CoreService } from '../../../../services/core.service';
import { SubmitGridComponent } from '../../components/submit-grid/submit-grid.component';
import { SectionGridComponent } from '../../components/section-grid/section-grid.component';
import { StepperGridComponent } from '../../components/stepper-grid/stepper-grid.component';
import { FooterGridComponent } from '../../components/footer-grid/footer-grid.component';

// Import Angular Material modules if using Material date picker
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
  selector: 'app-create-pricing-plan',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    SectionGridComponent,
    SubmitGridComponent,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
    StepperGridComponent,
    FooterGridComponent
  ],
  templateUrl: './create-pricing-plan.component.html',
  styleUrl: './create-pricing-plan.component.scss'
})
export class CreatePricingPlanComponent implements OnInit {
  publisherCommercialModelForm: FormGroup;
  companyId: string | null = null;
  contentSiteId: string | null = null;
  pricingPlans: any[] = [];
  showSubmit = true;

  @Output() onSubmitClbk = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private coreService: CoreService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.publisherCommercialModelForm = this.fb.group({
      title: ['', Validators.required],
      start_date: [''],
      end_date: [''],
      description: [''],
      pricing_plan_id: ['', Validators.required],
      payment_type: ['monthly']
    });
  }

  ngOnInit() {
    // Get company and site IDs from route parameters
    this.route.params.subscribe(params => {
      this.companyId = params['company'];
      console.log('Company ID from route:', this.companyId);

      if (this.companyId) {
        // Load pricing plans
        this.loadPricingPlans();
      }
    });

    // Check if editing existing pricing plan
    // if (this.formData?.ID) {
    //   this.loadPricingPlanData(this.formData.ID);
    // }
  }

  private loadPricingPlans(): void {
    // Load pricing plans for selection
    this.coreService.getData('/manageAccount/pricing-plans').subscribe({
      next: (data) => {
        console.log(data);
        this.pricingPlans = data || [];
        console.log('Loaded pricing plans:', this.pricingPlans);
      },
      error: (error) => {
        console.error('Error loading pricing plans:', error);
      }
    });
  }

  private loadPricingPlanData(planId: string): void {
    this.coreService.getData(`manageAccount/pricing-plan/${planId}`).subscribe({
      next: (data) => {
        this.publisherCommercialModelForm.patchValue(data);
      },
      error: (error) => {
        console.error('Error loading pricing plan data:', error);
      }
    });
  }

  onSubmit(): void {
    if (this.publisherCommercialModelForm.valid) {
      // Get form values
      const formData = this.publisherCommercialModelForm.value;

      // Add companyID and contentSiteID from route params
      const dataToSubmit = {
        ...formData,
        company_id: this.companyId,
        begins_at: formData.start_date,
      };

      // Determine if this is create or update
      // const endpoint = this.formData?.ID 
      //   ? `manageAccount/pricing-plan/update/${this.formData.ID}`
      //   : 'manageAccount/pricing-plan/store';

      this.coreService.postData('manageAccount/company-pricing-plan/store', dataToSubmit).subscribe({
        next: (data) => {
          console.log('Pricing plan operation successful:', data);

          const companyId = data.company_id || data.data?.company_id;

          if (companyId) {
            this.router.navigate(['/manage-account/create-approve', companyId]);
          } else {
            console.error('No company ID found in response:', data);
          }

          // Optional: Reset form
          // this.resetForm();
        },
        error: (error) => {
          console.error('Error creating/updating pricing plan:', error);

          // Handle specific errors
          if (error.status === 400) {
            alert('Invalid pricing plan data. Please check your inputs.');
          } else if (error.status === 409) {
            alert('Pricing plan already exists.');
          }
        }
      });
    } else {
      this.markFormGroupTouched(this.publisherCommercialModelForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  resetForm(): void {
    this.publisherCommercialModelForm.reset({
      title: '',
      start_date: '',
      end_date: '',
      description: '',
      pricing_plan_id: '',
      payment_type: 'month'
    });

    this.publisherCommercialModelForm.markAsPristine();
    this.publisherCommercialModelForm.markAsUntouched();
  }
}
